<template>
  <div class="header">
    <nav class="navbar">
      <div class="container-fluid">
        <div class="logo">
          <img
            src="@/assets/images/zhop_logo3.svg"
            class="img-fluid"
            @click="goHome"
          />
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  methods: {
    goHome () {
      this.$router.push({ path: '/' });
    }
  }
}
</script>

<style lang="scss" scoped>
.logo {
  margin: 0 auto;
  display: inline-block;
  padding: 10px 0;
}

.logo img {
  max-width: 100%;
  cursor: pointer;
}
</style>
